/* base API path */

import { FlagGB, FlagRO, FlagUS } from "../UI_utils/FlagIcons";
import React from "react";

// const DEV_ENDPOINT = "https://ufc.dev.upswing.ro";
const DEV_ENDPOINT = process.env.REACT_APP_WRITER_API || "https://api.writer.seomonitor.com";
export const REACT_APP_SENTRY_DSN="https://d761369abc80da9fd8ac548dce952b6f@errors.seomonitor.com/17"
// const DEV_ENDPOINT = "http://api.writer.seomonitor.ro";
// const isProduction = process.env.NODE_ENV === "production";
// export const BASE_URL = isProduction ? PROD_ENDPOINT : DEV_ENDPOINT;
export const BASE_URL = DEV_ENDPOINT;

export const SPACE_API_KEY = 'f885987a-dd2a-443f-9486-ba93dbd9f596'


export const IMAGE_UPLOAD_PATH = "api/articles/upload-image";
// export const CSV_TEMPLATE_DOWNLOAD =
//   "https://api.writer.seomonitor.com/files/example.csv";
export const CSV_TEMPLATE_DOWNLOAD = "https://api.writer.seomonitor.com/files/example.csv";

/* error messages */
export const AUTH_ERR = "Your credentials have expired, please login again.";
export const GENERIC_ERR =
  "An error has occured during your last action. Please try again later or contact support.";

/* pages navigation path */
export const LOGIN_PATH = "/login";
export const REGISTER_PATH = "/register";
export const MULTI_STEP_REGISTER = "/multistep-register";
export const RESET_PASS_PATH = "/reset-password";
export const CHANGE_PASS_PATH = "/change-password";
export const HOME_PATH = "/article";
export const SHARED_ARTICLE = "/shared-article/:sharedToken";
export const DEMO_APP_PATH = `/demo${HOME_PATH}`;
export const ESHOP_PATH = "/eshop";
export const NATIVE_PATH = "/native";
export const DASHBOARD_PATH = "/dashboard";
export const CLIENT_BRIEF_PATH = "/project-brief";
export const CLIENTS_DASHBOARD_PATH = "/projects-list";
export const PERFORMANCE_DASHBOARD_PATH = "/performance";
export const PROJECTS_PERFORMANCE_DASHBOARD_PATH = "/projects";
export const SEARCH_RESULTS_PATH = "/search-results";
export const AI_OUTLINE_PATH = "/outline";

/* other utilities consts */
export const DEFAULT_ARTICLE_ID = "1";
export const DEFAULT_ESHOP_ID = "1";
export const DEFAULT_NATIVE_ID = "1";
export const TYPE_ARTICLE = 0;
export const TYPE_DESCRIPTION = 1;
export const TYPE_NATIVE = 2;
export const NOTIFICATION_SERVER_ERROR =
  "Error retrieving data. Please try again later, or search for a different topic.";
export const OPEN_MODAL_INTERVAL = 500;
export const MAX_IMAGES_ALLOWED = 40;
export const IMG_PARTIALLY_ALLOWED = "NOT ALL IMAGES WERE UPLOADED";
export const IMG_NOT_ALLOWED = "YOU EXCEEDED THE MAXIMUM NUMBER OF IMAGES";

/* dashboard deadlines */
export const IN_TIME = "deadline-in-time";
export const DEADLINE_CLOSE = "deadline-close"; // one day until deadline
export const DEADLINE_PASSED = "deadline-passed"; // deadline today or passed
/* dashboard event types (endpoints)*/
export const ASSIGN = "asign";
export const UNASSIGN = "unasign";
/* dashboard properties (columns) - used to update the local state dynamically */
export const CREATED = "created";
export const DEADLINE = "deadline";
export const FEEDBACK = "feedback";
export const INDUSTRY = "industry";
export const PROJECT = "project";
export const PROOFREADER = "proofreader";
export const STATUS = "status";
export const TOPIC = "topic";
export const WRITER = "writer";
export const WRITER_NAME = "writerName";
export const ESTIMATED_VISITS = "estimatedVisits";
export const TYPE = "type";
export const SIMILARITY = "plagiarism";

/* dashboard menu actions */
export const WRITER_ASSIGN = "Assign writer";
export const WRITER_UNASSIGN = "Unassign writer";
export const WRITER_SWITCH = "Assign another writer";
export const PROOFREADER_ASSIGN = "Assign proofreader";
export const PROOFREADER_UNASSIGN = "Unassign proofreader";
export const PROOFREADER_SWITCH = "Assign another proofreader";
export const DEADLINE_CHANGE = "Change deadline";
export const CREATION_CHANGE = "Change creation date";
export const ARTICLE_DELETE = "Delete article";
export const ARTICLE_DELETE_BULK = "Delete bulk article";
export const CREATE_DASHBOARD_ENTRY = "create-new";
export const CREATE_DASHBOARD_DESCRIPTION_ENTRY = "create-new-description";
export const CREATE_DASHBOARD_NATIVE_ENTRY = "create-new-native";
export const RENAME_TOPIC = "Rename topic";
export const STATUS_CHANGE = "Change status";
export const EDIT_ENTRY = "Edit article";
export const EDIT_LIVE_URL = "Edit live URL";

/* projects dashboard actions */
export const ADD_NEW_PROJECT = "Add new project";
export const MANAGE_PROJECT_MEMBERS = "Manage members";
export const EDIT_MEMBER_ROLE = "Edit member role";

// dashboard types
export const DASH_MANAGEMENT = "management";
export const DASH_PERFORMANCE = "performance";
export const DASH_BRIEFS = "brief";

/* user roles */
export const USER_MASTER = "ROLE_MASTER";
export const USER_PROOFREADER = "ROLE_PROOFREADER";
export const USER_WRITER = "ROLE_WRITER";
export const USER_CLIENT = "ROLE_CLIENT";
export const USER_SUBCLIENT = "ROLE_SUBCLIENT";

/* feedback button message and actions */
export const WRITER_SUBMIT = {
  action: "asign-to-proof",
  message: "Submit",
};

export const WRITER_FEEDBACK = {
  action: "asign-to-proof",
  message: "Submit",
};

export const PROOF_FEEDBACK = {
  action: "submit-feedback",
  message: "Submit",
};

export const PROOF_NO_FEEDBACK = {
  action: "no-feedback",
  message: "Submit",
};

export const ROUND2_NO_FEEDBACK = {
  action: "no-feedback",
  message: "Submit",
};

export const ROUND2_PROOF_FEEDBACK = {
  action: "submit-feedback",
  message: "Submit",
};

export const Queries = {
  SEARCH_RESULTS: "search-results",
  AI_RESULTS: "ask-ai",
  ARTICLE_OUTLINE: "article-outline",
  COMPETITION_HEADINGS: "competition-headings",
  HEADING_KEYWORDS: "heading-keywords",
  CONTENT_DATA: "content-data",
};

export const countries = [
  { value: "RO", label: "RO", icon: <FlagRO width={20} /> },
  { value: "GB", label: "GB", icon: <FlagGB width={20} /> },
  { value: "US", label: "US", icon: <FlagUS width={20} /> },
];

export const TEXTS = {
  NO_ARTICLES_LEFT: (
    <div style={{ whiteSpace: "pre-line" }}>
      You don't have any articles left for this campaign.
      <br />
      Review your Writer Billing settings.
    </div>
  ),
  NO_ARTICLES_LEFT_MODAL_TITLE_ADMIN: "Article Limit Reached",
  NO_ARTICLES_LEFT_MODAL_BODY_ADMIN: "You've used all available articles. To continue creating content, please update your plan in the billing section.",
  NO_ARTICLES_LEFT_MODAL_TITLE_GUEST: "Article Limit Reached",
  NO_ARTICLES_LEFT_MODAL_BODY_GUEST: "You've used all available articles. To access more articles, please contact your account manager to update the plan.",
  FRESH_PERSPECTIVE_TOOLTIP: "<strong>Fresh Perspective.</strong> Introduces new<br />content or value from a different market<br />or angle, distinct from top-ranking<br />articles. Offers unique insights to stand<br />out in search results.",
  NORMAL_ARTICLE_TOOLTIP: "<strong>Authority enhancer.</strong> Similar to existing<br />content but refined for better<br />performance. Ideal for websites already<br />ranking well for the topic, aiming to<br />solidify or improve their position.",
  COMPREHENSIVE_ARTICLE_TOOLTIP: "<strong>Comprehensive Guide.</strong> Covers the topic<br />extensively, answering most questions<br />addressed by top-ranking articles. Aims<br />to be the go-to resource for the subject.",
  GLOBAL_SV: "For global campaigns, we rely on the US database as it<br />offers the most relevant data from the largest market.<br />Search Volume discrepancies may occur between Rank<br />Tracker and Content Writer.",
  EXTERNAL_ARTICLE: "External article - performance metrics are only tracked for content published on your website.",
  OUTLINE_TAB_TOOLTOP: "AI-generated initial article<br />structure that you can modify to<br />shape your content direction.<br />SEO score reflects keyword<br />presence across headings,<br />showing ranking potential<br />based on your target keywords.",
  OUTLINE_TAB_TOOLTOP_SHARED: "Initial article structure that<br />you can modify to shape your<br />content direction.<br />SEO score reflects keyword<br />presence across headings,<br />showing ranking potential<br />based on your target keywords.",
  GENERATED_TAB_TOOLTOP: "AI-generated draft created by<br />processing your SEO brief,<br />campaign settings, article<br />guidelines, outline data, SERP<br />analysis, and website insights.<br />Review-only mode with option to<br />copy content to your Working<br />Draft.",
  DRAFT_TAB_TOOLTOP: "Full-featured WYSIWYG editor<br />where you customize content while<br />monitoring real-time SEO<br />effectiveness. Score updates as<br />you edit, showing how well your<br />content matches target keywords<br />and ranking potential.",
  LIVE_TAB_TOOLTOP: "View the currently published<br />version's SEO performance for<br />comparison with your Working<br />Draft. Track how your live content<br />ranks against your target keywords<br />to identify optimization<br />opportunities.",
  READ_ONLY_TOOLTIP_AI: "AI Version is a read-only mode view. Copy it to Working Draft to start editing.",
  READ_ONLY_TOOLTIP_LIVE: "Live Version is a read-only mode view. Copy it to Working Draft to start editing.",
};